const getDV = (T: number): string => {
  let M = 0;
  let S = 1;
  for (let value = T; value > 0; value = Math.floor(value / 10)) {
    S = (S + (value % 10) * (9 - (M++ % 6))) % 11;
  }
  return S ? (S - 1).toString() : 'K';
};

const validateRut = (rut: string): boolean => {
  const noDotsRut = rut.replace(/\./g, '').replaceAll(' ', '');
  if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(noDotsRut)) {
    return false;
  }
  const rutParts = noDotsRut.split('-');
  const rutDV = rutParts[1].toUpperCase();
  const rutNumber = parseInt(rutParts[0], 10);
  return rutDV === getDV(rutNumber);
};

export default validateRut;
